export default __webpack_public_path__ + "static/media/laundry.bc29cc61.png";